module.exports = __webpack_public_path__ + "static/media/digital.fd2dad49.jpg";